module.exports = __webpack_public_path__ + "static/img/CGR.97a8c12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/CGR.png
// module id = 6Nyt
// module chunks = 1